import { v1ServerByProjectAuth } from "server/index/serverInstances";
import {
  createMetadataImageRequest,
  createMetadataImageResponse,
  createMetadataRequest,
  createMetadataResponse,
  createResourceRegistryListRequest,
  createResourceRegistryListResponse,
  getMetadataImageListRequest,
  getMetadataImageListResponse,
  getMetadataListRequest,
  getMetadataListResponse,
  getMetadataTemplateRequest,
  getMetadataTemplateResponse,
  getResourceRegistryListRequest,
  getResourceRegistryListResponse,
  updateMetadataImageRequest,
  updateMetadataImageResponse,
  updateMetadataRequest,
  updateMetadataResponse,
} from "./index.type";
import { makeQuery } from "server/index/utils";

//metadata등 사용자 입력을 위한 템플릿 조회
const getMetadataTemplate = async (
  request: getMetadataTemplateRequest
): Promise<getMetadataTemplateResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/metadata-manager/templates`,
    query: makeQuery(request.query),
  });

// 사용자가 저장한 Metadata 목록 조회
const getMetadataList = async (
  request: getMetadataListRequest
): Promise<getMetadataListResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/metadata-manager/metadatas`,
    query: makeQuery(request.query),
  });

// metadata 생성
const createMetadata = async (
  request: createMetadataRequest
): Promise<createMetadataResponse> =>
  await v1ServerByProjectAuth.post({
    path: `/metadata-manager/metadatas`,
    query: makeQuery(request.query),
    data: request.data,
    config: {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  });

// metadata 수정
const updateMetadata = async (
  request: updateMetadataRequest
): Promise<updateMetadataResponse> =>
  await v1ServerByProjectAuth.put({
    path: `/metadata-manager/metadatas/${request.params.metadataId}`,
    query: makeQuery(request.query),
    data: request.data,
  });

//이미지 목록 조회
const getMetadataImageList = async (
  request: getMetadataImageListRequest
): Promise<getMetadataImageListResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/metadata-manager/images`,
    query: makeQuery(request.query),
    data: request.data,
  });

//이미지 생성
const createMetadataImage = async (
  request: createMetadataImageRequest
  // onProgress?: (progress: number) => void // 진행 상태 콜백 추가
): Promise<createMetadataImageResponse> =>
  await v1ServerByProjectAuth.post({
    path: `/metadata-manager/images`,
    query: makeQuery(request.query),
    data: request.data,
    config: {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      // onUploadProgress: (progressEvent: any) => {
      //   // 진행 상황 계산
      //   if (progressEvent.total && onProgress) {
      //     console.log(progressEvent);
      //     const progress = Math.round(
      //       (progressEvent.loaded * 100) / progressEvent.total
      //     );
      //     onProgress(progress); // 진행 상태 콜백 호출
      //   }
      // },
    },
  });

//이미지 수정
const updateMetadataImage = async (
  request: updateMetadataImageRequest
): Promise<updateMetadataImageResponse> =>
  await v1ServerByProjectAuth.put({
    path: `/metadata-manager/images/${request.params.imageId}`,
    query: makeQuery(request.query),
    data: request.data,
  });

const getResourceRegistryList = async (
  request: getResourceRegistryListRequest
): Promise<getResourceRegistryListResponse> =>
  await v1ServerByProjectAuth.get({
    path: `/metadata-manager/resource-registries`,
    query: makeQuery(request.query),
    data: request.data,
  });

const createResourceRegistryList = async (
  request: createResourceRegistryListRequest
): Promise<createResourceRegistryListResponse> =>
  await v1ServerByProjectAuth.post({
    path: `/metadata-manager/resource-registries`,
    query: makeQuery(request.query),
    data: request.data,
  });

export {
  getMetadataTemplate as getMetadataTemplateFromServer,
  getMetadataList as getMetadataListFromServer,
  createMetadata as createMetadataFromServer,
  updateMetadata as updateMetadataFromServer,
  getMetadataImageList as getMetadataImageListFromServer,
  createMetadataImage as createMetadataImageFromServer,
  updateMetadataImage as updateMetadataImageFromServer,
  getResourceRegistryList as getResourceRegistryListFromServer,
  createResourceRegistryList as createResourceRegistryListFromServer,
};
